import React from "react";
import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import user$ from "store/user";
import { User$ } from "types/user";
import { useRouter } from "next/router";
import { useCheckAuth } from "store/auth";
import { useObservable } from "helpers/observable";
import { AppLayout } from "components/layout/layout";
import { ProfileForm } from "components/UserProfileForm";
import { ProfileIBan } from "components/UserProfileIBan";
import { ProfilePhoto } from "components/UserProfilePhoto";
import { UserProfileNav } from "components/UserProfileNav";
import { ProfileInputs } from "components/UserProfileInput";

interface Props {}
function UserProfile({}: Props): JSX.Element {
    useCheckAuth();
    const router = useRouter();
    const { t } = useTranslation();
    const user = useObservable<User$>(user$);

    return (
        <AppLayout>
            <div className="container pt-5">
                <div className="row">
                    <div className="d-none d-lg-block col-lg-3">
                        <UserProfileNav />
                    </div>
                    <div className="col-12 col-lg-9">
                        {/* -------------- */}
                        <div className="userSec pt-5 mb-5">
                            <div className="tpSEc px-lg-5 pb-lg-5">
                                <div className="d-flex flex-column flex-lg-row">
                                    <div className="d-block d-lg-none text-center pb-4">
                                        <h5>{t("common:user.myprofile")}</h5>
                                    </div>
                                    <span className="profileprogress d-none d-lg-block me-5">
                                        <img
                                            src={user?.avatar}
                                            alt="user icon"
                                            className="profile-picture"
                                        />
                                    </span>
                                    <div className="d-lg-none">
                                        <ProfilePhoto user={user} />
                                    </div>
                                    <div className="text-center text-lg-left pt-lg-2 mb-5">
                                        <h3 className="Uname pt-3 pt-lg-0">
                                            {user?.first_name} {user?.last_name}
                                        </h3>
                                        <p
                                            className="Uemail d-none d-lg-block"
                                            dir="ltr"
                                        >
                                            {user?.email || user?.phone}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="btSEc p-lg-5">
                                <div className="row d-none d-lg-block">
                                    <div className="myprofile-desktop">
                                        <h3>{t("common:user.myprofile")}</h3>
                                        <ProfilePhoto user={user} />
                                    </div>
                                    <div className="col-12"></div>
                                </div>
                                <ProfileForm user={user} />
                                {/* <ProfileIBan user={user} className="px-3 px-lg-0 pt-lg-5 mb-4" /> */}
                                <ProfileInputs user={user} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
}

export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale as string, [
            "common",
            "errors",
        ])),
    },
});

export default React.memo(UserProfile);
